module.exports = __webpack_public_path__ + "img/spin_btn.61656c20.png";